import classes from './ChatWidget.module.scss'
import { ChatHistoryItem } from './types'
import { historyGroupLabel } from './historyMappers'
import { IconPlus } from './icons'

interface Props {
  open: boolean
  sessions: ChatHistoryItem[]
  activeConversationId: number | null
  onNewChat: () => void
  onSelect: (conversationId: number) => void
  onDelete: (conversationId: number) => void
  disabled?: boolean
}

/** İlk kullanıcı mesajından kısa başlık üretir (başlık kuralının tek kaynağı). */
export function deriveHistoryTitle(firstUserText: string) {
  const trimmed = (firstUserText || 'Yeni Sohbet').trim().replace(/\s+/g, ' ')
  return trimmed.length > 48 ? `${trimmed.slice(0, 48)}…` : trimmed
}

/** Sol sidebar: "Yeni Sohbet" + son 14 günün sunucudan gelen sohbet geçmişi. */
export default function HistorySidebar({
  open,
  sessions,
  activeConversationId,
  onNewChat,
  onSelect,
  onDelete,
  disabled,
}: Props) {
  const now = Date.now()
  let lastLabel = ''

  return (
    <div className={`${classes.sidebar} ${classes.sidebarLeft}`} aria-hidden={!open}>
      <div className={classes.sidebarInner}>
        <div className={classes.sidebarHead}>
          <button type='button' className={classes.newChatBtn} onClick={onNewChat} disabled={disabled}>
            <IconPlus />
            Yeni Sohbet
          </button>
        </div>
        <div className={classes.sidebarBody}>
          {sessions.length > 0 ? (
            sessions.map(s => {
              const label = historyGroupLabel(s.lastActivityUtc, now)
              const showLabel = label !== lastLabel
              lastLabel = label
              const title = deriveHistoryTitle(s.firstUserText)

              return (
                <div key={s.conversationId}>
                  {showLabel && <div className={classes.sidebarSection}>{label}</div>}
                  <div className={classes.historyRow}>
                    <button
                      type='button'
                      className={classes.historyItem}
                      onClick={() => onSelect(s.conversationId)}
                      disabled={disabled}
                      title={title}
                      aria-current={s.conversationId === activeConversationId ? 'true' : undefined}
                    >
                      {title}
                    </button>
                    <button
                      type='button'
                      className={classes.historyDeleteBtn}
                      onClick={() => onDelete(s.conversationId)}
                      disabled={disabled}
                      aria-label={`${title} sohbetini sil`}
                      title='Sohbeti sil'
                    >
                      ×
                    </button>
                  </div>
                </div>
              )
            })
          ) : (
            <div className={classes.sidebarEmpty}>Henüz geçmiş sohbet yok</div>
          )}
        </div>
      </div>
    </div>
  )
}
